import axios from 'axios';
import { config } from '@/config';

/**
 * Lee las credenciales actuales del perfil desde localStorage.
 *
 * @returns {{ token: string, hashTeatro: string }}
 */
export function getPerfilCredentials() {
    return {
        token: localStorage.getItem('token') || '',
        hashTeatro: localStorage.getItem('hash_teatro') || '',
    };
}

/**
 * Añade las credenciales del perfil a una URL absoluta o relativa.
 *
 * @param {string} url
 * @returns {string}
 */
export function withPerfilCredentials(url) {
    if (!url) return '';

    const { token, hashTeatro } = getPerfilCredentials();
    const separator = url.includes('?') ? '&' : '?';

    return `${url}${separator}api_key=${token}${hashTeatro ? `&tid=${hashTeatro}` : ''}`;
}

/**
 * Crea un cliente axios para la API principal del perfil (PerfilV2).
 *
 * Lee `token` y `hash_teatro` de localStorage en el momento de la llamada
 * para garantizar que siempre se usan credenciales frescas.
 *
 * @returns {import('axios').AxiosInstance}
 */
export function createPerfilApiClient() {
    const { token, hashTeatro } = getPerfilCredentials();

    return axios.create({
        baseURL: config.API_BASE,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': token,
            'Autrollization': token,
            'Hash-Teatro': hashTeatro,
        },
    });
}
